module.exports = __webpack_public_path__ + "img/ford-logo-mobile.104483fa.png";